<template>
    <div id="nav">
        <div class="left">
            <a class="logo" href="">
                <img :src="userTheme === 'dark' ? require('@/assets/brand/dbg-markets-lockup-light.png') : require('@/assets/brand/dbg-markets-lockup.png')"
                     alt="DBG Markets">
            </a>
            <nav class="nav-menu">
                <!--    市场行情    -->
                <div class="nav-menu-item" @click="$router.push('/quotes')">
                    <span class="menu-text">{{ $t('nav.market_quotes') }}</span>
                </div>
                <!--    现货交易    -->
                <div class="nav-menu-item" @click="$router.push('/spot')">
                    <span class="menu-text">{{ $t('nav.spot_trading') }}</span>
                </div>
                <!--    衍生品    -->
                <div class="nav-menu-item">
                    <span class="menu-text">{{ $t('nav.derivatives') }}</span>
                    <div class="submenu">
                        <div class="submenu-item" @click="$router.push('/futures')">
                            <img :src="require(`@/assets/images/navbar/hy-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.contract_trading') }}</span>
                        </div>
                        <div class="submenu-item" @click="$router.push('/flashOption')">
                            <img :src="require(`@/assets/images/navbar/sf-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.options_trading') }}</span>
                        </div>
<!--                        <div class="submenu-item" @click="$router.push('/copyTraders')">-->
<!--                            <img :src="require(`@/assets/images/navbar/hygd-${userTheme}.png`)" alt="">-->
<!--                            <span>跟单交易</span>-->
<!--                        </div>-->
                    </div>
                </div>
                <!--   暴富理财   -->
                <div class="nav-menu-item">
                    <span class="menu-text" @click="$router.push('/investment')">{{ $t('nav.wealth_management') }}</span>
                    <div class="submenu">
                        <div class="submenu-item" @click="$router.push('/easyEarn')">
                            <img :src="require(`@/assets/images/navbar/hbb-${userTheme}.png`)" alt="">
                            <span>{{ $t('nav.staking_interest') }}</span>
                        </div>
<!--                        XAU Pledge is temporarily unavailable. Keep /term registered for existing links. -->
<!--                        <div class="submenu-item" @click="$router.push('/term')">-->
<!--                            <img :src="require(`@/assets/images/navbar/bflc-${userTheme}.png`)" alt="">-->
<!--                            <span>{{ $t('nav.wealth_products') }}</span>-->
<!--                        </div>-->
<!--                        <div class="submenu-item" @click="$router.push('/pledge')">-->
<!--                            <img :src="require(`@/assets/images/navbar/ptzy-${userTheme}.png`)" alt="">-->
<!--                            <span>平台币质押理财</span>-->
<!--                        </div>-->
<!--                        <div class="submenu-item" @click="$router.push('/fund')">-->
<!--                            <img :src="require(`@/assets/images/navbar/gfjj-${userTheme}.png`)" alt="">-->
<!--                            <span>共富基金</span>-->
<!--                        </div>-->
                    </div>
                </div>
                <!--
                  盲盒功能入口已暂时下线。恢复时需同步取消 /BindBox 路由的注释。
                  <div class="nav-menu-item">
                    <span class="menu-text">{{ $t('nav.blind_box') }}</span>
                    <div class="submenu">
                      <div class="submenu-item" @click="$router.push('/BindBox')">
                        <img :src="require(`@/assets/images/navbar/bfmh-${userTheme}.png`)" alt="">
                        <span>{{ $t('nav.blind_box') }}</span>
                      </div>
                    </div>
                  </div>
                -->
                <!--    帮助中心    -->
                <div class="nav-menu-item" @click="$router.push('/help')">
                    <span class="menu-text">{{ $t('nav.help_center') }}</span>
                </div>
            </nav>
        </div>
        <div class="right">
            <template v-if="!isLogin">
                <a-button class="login button" @click="$router.push('/login')">{{ $t('nav.login') }}</a-button>
                <a-button class="enroll button" @click="$router.push('/register')">{{ $t('nav.register') }}</a-button>
            </template>
            <template v-if="isLogin">
                <div class="imgBox" @click="$router.push('/HomeView/assets')">
                    <icon-archive/>
                </div>
                <div class="imgBox">
                    <icon-file/>
                    <div class="menuPopup">
                        <p class="font-16 _title color-black font-bold">{{ $t('nav.trading_records') }}</p>
                        <div class="popBox">
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:1}})">
                                <span class="font-14 color-black">{{ $t('nav.spot_trading') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:2}})">
                                <span class="font-14 color-black">{{ $t('nav.futures_trading') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:3}})">
                                <span class="font-14 color-black">{{ $t('nav.options_trading') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push({path:'/HomeView/assets',query:{menu:6,account:4}})">
                                <span class="font-14 color-black">{{ $t('nav.fund_account') }}</span>
                                <icon-right size="16"/>
                            </div>
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">闪兑交易记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">理财交易记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
<!--                            <div class="row">-->
<!--                                <span class="font-14 color-black">质押借贷记录</span>-->
<!--                                <icon-right size="16"/>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </template>
            <a-tooltip background-color="var(--tooltip-bg)" :content="$t('common.customer_service')">
                <button
                    type="button"
                    class="imgBox customer-service-control"
                    :aria-label="$t('common.customer_service')"
                    :disabled="isOpeningCustomerService"
                    @click="openCustomerService"
                >
                    <icon-customer-service size="22" />
                </button>
            </a-tooltip>
            <div class="imgBox notification-control">
                <icon-notification/>
            </div>
            <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.theme_mode')">
                <button type="button" class="imgBox theme-toggle" @click="toggleUserTheme" :aria-label="$t('nav.theme_mode')">
                    <icon-sun-fill v-if="userTheme === 'dark'" size="22"/>
                    <icon-moon-fill v-else size="22"/>
                </button>
            </a-tooltip>
            <div class="imgBox account-menu-control">
                <icon-menu v-if="!isLogin"/>
                <img v-else class="userImg" @click="$router.push('/HomeView/personal')" src="@/assets/images/avatar.png"
                     alt="">
                <div class="menuPopup">
                    <div class="cell">
                        <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.language_region')">
                            <div class="item" @click="languagePop = true">
                                <icon-language size="22" class="mr-10"/>
                                <span>{{ langText }}</span>
                            </div>
                        </a-tooltip>
                        <a-tooltip background-color="var(--tooltip-bg)" :content="$t('nav.exchange_rate')">
                            <div class="item" @click="languagePop = true">
                                <icon-common size="22" class="mr-10"/>
                                <span>{{ exchangeText.split(' - ')[0] }}</span>
                            </div>
                        </a-tooltip>
                    </div>
                    <template v-if="!isLogin">
                        <a-button class="button" @click="toDownload">
                            <icon-download class="mr-10" size="20"/>
                            {{ $t('nav.more_download') }}
                        </a-button>
                    </template>
                    <template v-else>
                        <div class="popBox">
                            <div class="info">
                                <div class="top">
                                    <img src="@/assets/images/avatar.png" alt="">
                                    <div class="right">
                                        <p class="font-16 color-black font-bold">{{ userNickname }}</p>
                                        <p class="font-13 color-gray">UID:{{ userId }}
                                            <icon-copy/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" @click="goToPersonalPage(1)">
                                <span class="font-14 color-black">{{ $t('nav.security_center') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="goToPersonalPage(2)">
                                <span class="font-14 color-black">{{ $t('nav.identity_verification') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">卡卷</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">地址簿</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <!--              <div class="row">-->
                            <!--                <span class="font-14 color-black">API密钥</span>-->
                            <!--                <icon-right size="16"/>-->
                            <!--              </div>-->
                            <div class="row" @click="$router.push('/HomeView/assets')">
                                <span class="font-14 color-black">{{ $t('nav.my_assets') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <div class="row" @click="$router.push('/HomeView/personal')">
                                <span class="font-14 color-black">{{ $t('nav.account_settings') }}</span>
                                <icon-right size="16"/>
                            </div>
                            <!--
                              邀请返佣入口已暂时下线。
                              <div class="row" @click="goToPersonalPage(4)">
                                <span class="font-14 color-black">{{ $t('nav.invitation_rebate') }}</span>
                                <icon-right size="16"/>
                              </div>
                            -->
                            <a-button class="quit" @click="loginOut">{{ $t('nav.logout') }}</a-button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!--  弹窗-->
        <a-modal :closable="false"
                 align-center
                 width="840px"
                 mask-closable
                 body-class="modelBox"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 :hide-title="false"
                 :footer="false"
                 :visible="languagePop">
            <div class="model">
                <a-tabs>
                    <template #extra>
                        <icon-close class="cursor close" size="20" @click="languagePop = false"/>
                    </template>
                    <a-tab-pane key="1" :title="$t('nav.language_region')">
                        <div class="list">
                            <div class="item" :class="langIndex == index ? 'active' : '' " v-for="(item,index) in lang"
                                 :key="index" @click="setLang(item, index)">
                                <span>{{ item.label }}</span>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" :title="$t('nav.exchange_rate')">
                        <div class="list">
                            <div class="item" :class="exchangeIndex == index ? 'active' : '' "
                                 v-for="(item,index) in exchange"
                                 :key="item.code" @click="setExchange(item)">
                                <span>{{ item.code }} - {{ item.symbol }}</span>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </a-modal>
    </div>
</template>

<script>
import WOW from "wow.js";
import {
    mapGetters
} from 'vuex';
import {
    DISPLAY_CURRENCIES,
    getDisplayCurrencyIndex,
    getDisplayCurrencyText
} from '@/common/constants/displayCurrencies';
import commonApi from '@/common/api/common';

export default {
    name: 'pageNav',
    components: {
    },
    props: {
        menuShow: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            downpop: false,
            languagePop: false,
            coinPop: false,
            langIndex: 0,
            propertyOption: [
                {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.overview')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.fund_account')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.spot_account')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.futures_account')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.options_account')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.finance_account')
                }, {
                    src: require("@/assets/navIcon1.png"),
                    text: this.$t('capital_flow.title')
                }],
            property: false,
            order: false,
            orderList: [
                {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.spot_orders')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.futures_orders')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.finance_orders')
                },
            ],
            usOption: [
                {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.account_security')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.identity_auth')
                },
                // 邀请返佣入口已暂时下线：
                // {
                //     src: require("@/assets/navIcon1.png"),
                //     text: this.$t('personal.invite_commission')
                // },
                {
                    src: require("@/assets/navIcon1.png"),
                    text: "API"
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.preference_settings')
                }, {
                    src: require("@/assets/navIcon1.png"),
                                                text: this.$t('nav.logout')
                },
            ],
            uspop: false,
            logType: true,
            langText: this.$t('nav.simplified_chinese_language'),
            lang: [],
            exchange: DISPLAY_CURRENCIES.filter((currency) => currency.enabled),
            currencySwitching: false,
            isOpeningCustomerService: false,
            customerServiceUrl: '',
            customerServiceConfigRequest: null
        }
    },
    mounted() {
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
        });
        wow.init();
        this.getLang()
        // this.logType = this.isLogin
    },
    computed: {
        ...mapGetters(['isLogin', 'userId', 'userTheme', 'userNickname', 'displayCurrency']),
        exchangeIndex() {
            return getDisplayCurrencyIndex(this.displayCurrency);
        },
        exchangeText() {
            return getDisplayCurrencyText(this.displayCurrency);
        }
    },
    methods: {
        loginOut() {
            this.$store.commit('userLogin', false);
            this.$router.push('/login');
        },
        toggleUserTheme() {
            const nextTheme = this.userTheme === 'dark' ? 'light' : 'dark';
            this.$store.commit('updateTheme', nextTheme);
        },
        routerLink(subItem) {
            this.$router.push(subItem.pageUrl)
        },
        routerPage(menu) {
            this.$router.push(menu.href)
        },
        toSport() {
            this.$router.push("/HomeView/spot")
        },
        toDownload() {
            console.log('📱 点击更多下载选择按钮');
            this.$router.push("/HomeView/appDownload")
        },
        toAssets() {
            this.$router.push("/HomeView/assets")
        },
        toPersonal() {
            this.$router.push("/HomeView/personal")
        },
        toOrder() {
            this.$router.push("/HomeView/order")
       },
        async openCustomerService() {
            if (this.isOpeningCustomerService) {
                return;
            }

            this.isOpeningCustomerService = true;
            let customerServiceWindow = null;
            try {
                const configuredUrl = this.getCustomerServiceUrl(this.$store.state.config);
                if (this.isExternalCustomerServiceUrl(configuredUrl)) {
                    this.openCustomerServiceWindow(configuredUrl);
                    return;
                }

                // Open during the click event so the browser does not block the later config request.
                customerServiceWindow = window.open('', '_blank');
                if (customerServiceWindow) {
                    customerServiceWindow.opener = null;
                }

                const customerServiceUrl = await this.loadCustomerServiceUrl();
                if (this.isExternalCustomerServiceUrl(customerServiceUrl)) {
                    if (customerServiceWindow) {
                        customerServiceWindow.location.replace(customerServiceUrl);
                    } else {
                        this.openCustomerServiceWindow(customerServiceUrl);
                    }
                    return;
                }

                if (customerServiceWindow) {
                    customerServiceWindow.close();
                }
                this.$message.warning(this.$t('common.customer_service_not_configured'));
            } catch (error) {
                if (customerServiceWindow) {
                    customerServiceWindow.close();
                }
                console.error('打开客服失败:', error);
                this.$message.error(this.$t('common.failed'));
            } finally {
                this.isOpeningCustomerService = false;
            }
        },
        getCustomerServiceUrl(config) {
            const url = config?.zxkf || config?.kefu_url;
            return typeof url === 'string' ? url.trim() : '';
        },
        isExternalCustomerServiceUrl(url) {
            return /^https?:\/\/\S+$/i.test(url);
        },
        openCustomerServiceWindow(url) {
            const customerServiceWindow = window.open(url, '_blank');
            if (customerServiceWindow) {
                customerServiceWindow.opener = null;
            }
        },
        loadCustomerServiceUrl() {
            if (this.customerServiceUrl) {
                return Promise.resolve(this.customerServiceUrl);
            }

            if (!this.customerServiceConfigRequest) {
                this.customerServiceConfigRequest = commonApi.config(5)
                    .then((res) => {
                        this.customerServiceUrl = this.getCustomerServiceUrl(res?.data);
                        return this.customerServiceUrl;
                    })
                    .catch((error) => {
                        console.warn('获取客服配置失败:', error);
                        return '';
                    })
                    .finally(() => {
                        this.customerServiceConfigRequest = null;
                    });
            }

            return this.customerServiceConfigRequest;
        },
        usChange(index) {
            console.log(index);
            if (index == 5) {
                this.logType = false;
            }
        },
        getLang() {
            this.lang = [
                {label: this.$t('language.native_simplified_chinese'), value: 'zh_CN'},
                {label: this.$t('language.native_traditional_chinese'), value: 'zh_Hant'},
                {label: 'English', value: 'en-US'},
                {label: 'Français', value: 'fr'},
                {label: 'Español', value: 'es'},
                {label: 'Tiếng Việt', value: 'vi'},
                {label: this.$t('language.native_japanese'), value: 'ja'},
                {label: '한국어', value: 'ko'},
                {label: 'Deutsch', value: 'gm'},
                {label: 'Русский', value: 'ru'},
                {label: 'ไทย', value: 'th'},
                {label: this.$t('language.native_australian_english'), value: 'au'},
            ]
            let lang = this.$util.getCache('lang')
            if (!lang) {
                lang = 'en-US' // 默认语言为英文
            }
            for (const langKey in this.lang) {
                if (this.lang[langKey].value == lang) {
                    this.langText = this.lang[langKey].label
                    this.langIndex = parseInt(langKey)
                }
            }
            
            console.log(this.$util.getCache('lang'))
        },
        setLang(item, index) {
            console.log('🌐 切换语言:', item.label, item.value);
            this.langIndex = index;
            this.$util.setCache('lang', item.value)
            this.langText = item.label
            this.languagePop = false;
            
            // 更新i18n语言
            this.$i18n.locale = item.value;
            
            console.log('✅ 语言已更新:', this.langText);
            
            // 延迟重新加载页面，让用户看到语言切换效果
            setTimeout(() => {
            window.location.reload();
            }, 100);
        },
        async setExchange(item) {
            if (this.currencySwitching) {
                return;
            }

            this.currencySwitching = true;
            try {
                await this.$store.dispatch('switchDisplayCurrency', item.code);
                this.languagePop = false;
                this.$message.success(this.$t('personal.currency_setting_saved'));
            } catch (error) {
                console.error('获取汇率失败:', error);
                this.$message.error(this.$t('common.operation_failed_retry'));
            } finally {
                this.currencySwitching = false;
            }
        },
        // 跳转到个人中心页面并设置 activeKey
        goToPersonalPage(activeKey) {
            console.log('🔗 跳转到个人中心页面，activeKey:', activeKey);
            const targetPath = '/HomeView/personal';
            const currentPath = this.$route.path;
            const currentQuery = this.$route.query;
            
            // 如果当前路径相同且 activeKey 也相同，则不跳转
            if (currentPath === targetPath && parseInt(currentQuery.activeKey) === activeKey) {
                console.log('⚠️ 已在目标页面，无需跳转');
                return;
            }
            
            // 使用 replace 或 push 来跳转
            this.$router.push({
                path: targetPath,
                query: { activeKey: activeKey }
            }).then(() => {
                console.log('✅ 跳转成功');
            }).catch(err => {
                console.error('❌ 跳转失败:', err);
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import "./pagenav.scss";
</style>
